import type { ShortcutHandlerContext } from '../../../../../lib/types.js';
import { sendShortcutJson } from '../../../../../lib/response.js';

/** GET /api/bridges/local-shortcut/health */
export async function GET(ctx: ShortcutHandlerContext): Promise<void> {
  sendShortcutJson(ctx.res, 200, { ok: true });
}
